// GraphQL String! rejects null and non-string values (e.g. a User object).
export const asGraphQLString = (value) => {
  if (value == null) return ""
  if (typeof value === "string") return value
  if (typeof value === "number" || typeof value === "boolean") return String(value)
  if (typeof value === "object") {
    if (typeof value.email === "string" || typeof value.displayName === "string" || typeof value.forename === "string") {
      return ""
    }
    try {
      return JSON.stringify(value)
    } catch (err) {
      return ""
    }
  }
  return String(value)
}
